<template>
  <section class="bg-background-neutral-secondary space-y-4 rounded-2xl p-4">
    <h4 class="freedom-loyalty-text text-base font-medium">
      {{ $t('main.loyalty.howItWorks.title') }}
    </h4>
    <div class="text-text-neutral-primary space-y-1 text-base">
      <h4 class="font-bold">
        {{ $t('main.loyalty.howItWorks.description.title') }}
      </h4>
      <ol class="ml-1 font-medium">
        <li>{{ $t('main.loyalty.howItWorks.description.orderPay') }}</li>
        <li>{{ $t('main.loyalty.howItWorks.description.cashbackReturn') }}</li>
        <li>{{ $t('main.loyalty.howItWorks.description.newPrice') }}</li>
      </ol>
    </div>
  </section>
</template>
<script setup lang="ts"></script>
